import { DmsIcon, dmsIconDirective } from './DmsIcon';
export { DmsIcon, dmsIconDirective };
